<mat-expansion-panel class="embalse-panel" (opened)="onOpened()">
  <mat-expansion-panel-header>
    <mat-panel-title>Propiedades del embalse</mat-panel-title>
  </mat-expansion-panel-header>

  <div class="embalse-wrapper" [formGroup]="form">

    <div class="loading" *ngIf="loading">Cargando...</div>

    <ng-container *ngIf="!loading">

      <div class="section">
        <div class="section-subtitle">Dimensiones del embalse</div>

        <div class="fields-row fields-row--bases">
          <mat-form-field appearance="fill">
            <mat-label>Base pequeña (m2)</mat-label>
            <input matInput type="number" formControlName="baseSmall" min="0" step="0.01" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Base grande (m2)</mat-label>
            <input matInput type="number" formControlName="baseLarge" min="0" step="0.01" />
          </mat-form-field>
        </div>

        <div class="fields-row fields-row--height">
          <mat-form-field appearance="fill">
            <mat-label>Altura del embalse (m)</mat-label>
            <input matInput type="number" formControlName="height" min="0.01" step="0.01" />
          </mat-form-field>
        </div>

        <div class="actions-row">
          <button type="button" mat-stroked-button color="warn" class="reset-button"
            [disabled]="deleting" (click)="deleteData()">
            Limpiar
          </button>
        </div>

        <div class="current-row" *ngIf="maxCapacity != null">
          <div class="section-title">Capacidad maxima:</div>
          <div class="current-value mono">
            {{ maxCapacity }} <span class="unit">m3</span>
          </div>
        </div>

      </div>

    </ng-container>

  </div>
</mat-expansion-panel>
